import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-field-checkboxes',
    templateUrl: './field-checkboxes.component.html',
    styleUrls: ['./field-checkboxes.component.scss'],
    standalone: false
})
export class FieldCheckboxesComponent implements OnInit, OnChanges {
    @Input() options: [{ title: string; value: any; tooltip?: string }];
    @Input() optionWidth: number;
    @Input() optionColumnWidth?: string;
    @Input() colSize?: string;
    @Input() fillWidth?: boolean;
    @Input() readOnly?: boolean;
    @Input() model: any[];
    @Input() returnChecked: boolean = false;
    @Input() label?: string;
    @Input() error?: string;
    @Input() optionalString?: string;
    @Input() showBorder: boolean = true;
    @Output() modelChange = new EventEmitter();

    localError: any = '';

    constructor() {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.error) {
            if (typeof changes?.error?.currentValue === 'string' || changes?.error?.currentValue instanceof String) {
                this.localError = changes.error.currentValue;
            } else {
                this.localError = '';
            }
        }
    }

    emit($event) {
        if (this.readOnly) {
            return;
        }
        this.modelChange.emit($event);
    }

    check(value: string) {
        if (this.returnChecked) {
            this.emit(value);
            return;
        }
        let newModel = [...this.model];
        const index = newModel.indexOf(value);
        if (index != -1) {
            newModel.splice(index, 1);
        } else newModel.push(value);
        this.emit(newModel);
    }

    isActive(value: string) {
        return this.model && this.model.indexOf(value) != -1;
    }
}
